export const isNumeric = "A senha deve ser numérica;";
export const is6Digits = "Ter pelo menos 6 dígitos;";
export const isDifferentCPFandCNPJ = "Não pode ser igual CPF ou CNPJ;";
export const isNotRepeat =
  "Não ter repetições em sequência de mais de dois dígitos, como por exemplo: 111, 333;";
export const isNotSequencial =
  "Não pode ter sequências numéricas, como por exemplo: 123, 456";
export const isDifferentData = "Não usar sua data de nascimento.";
export const isConfirmPassword = "Os campos de nova senha e de confirmação de senha devem ser iguais.";
